<template>
  <v-card
    class="mx-auto pa-2 overflow-visible"
    outlined
  >
    <v-list-item>
      <v-list-item-content class="overflow-visible">
        <v-list-item-title class="headline mb-2">
          Bảng báo cáo giao hàng
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <DeliveryTable
      :data="data"
      :dataTable="dataTable"
    />
    
  </v-card>
</template>

<script>
import moment from 'moment'
import DeliveryTable from './DeliveryTable'

import RepositoryFactory from "@/repositories/RepositoryFactory";
const ReportRepository = RepositoryFactory.get('report');

  export default {
    components: {
      DeliveryTable
    },
    props: {
      dataTable: {
        default: () => ({})
      },
    },
    data () {
      return {
        data: [],
        filterForm: {
          dateRange: {
            startDate: moment().startOf('month').format('YYYY-MM-DD'),
            endDate: moment().endOf('month').format('YYYY-MM-DD'),
          },
          ministryIds: []
        },
      }
    },
    created() {
      Bus.$on('delivery-status-report', (filterForm) => {
        this.filterForm = filterForm
        this.search()
      })
    },
    beforeDestroy() {
      Bus.$off('delivery-status-report')
    },
    methods: {
      search() {
        this.getData()
      },
      async getData() {
        const loader = this.$loading.show()
        const params = {
          startDate: moment(this.filterForm.dateRange.startDate).format('YYYY-MM-DD'),
          endDate: moment(this.filterForm.dateRange.endDate).format('YYYY-MM-DD'),
          // ministryIds: this.filterForm.ministryIds,
          orgIds: this.filterForm.ministryIds.filter(userItem => userItem.hasOwnProperty('orgId')).map(itemMap => itemMap.orgId),
          departmentType: 'retail',
          schoolLevelId: this.$store.state.module.schoolLevelId,
          typeId: this.$store.state.module.typeId
        };
        // Get data Báo cáo bảng giao hàng
        const response = await ReportRepository.deliveryReportByPerson(params)

        loader.hide()
        if (response.success) {
          this.data = _.get(response, 'data', [])
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  .ct-major-second {
    svg {
      position: relative;
    }
    &:before {
      padding-bottom: 0;
    }
  }
</style>